import { gsap } from 'gsap';
import { generate } from 'short-uuid';

interface IExpandableBlock {
  element: Element;
  expandButton: Element | null;
  expandableContentWrapper: Element | null;
  expandableContent: Element | null;
  expandableScroll: Element | null;
  expandedHeight: number;
}

const expandableBlocks: IExpandableBlock[] = [];

export class ExpandableBlock {
  constructor(element: Element) {
    const id = generate();
    if (!element.id) {
      element.id = `expandableBlock_${id}`;
    }

    const expandButton = element.querySelector('.btn-expand');
    const expandableContentWrapper = element.querySelector('.expandable-content-wrapper');
    const expandableScroll = element.querySelector('.expand-scroll');
    const expandableContent = element.querySelector('.expandable-content');
    const expandedHeight = element.querySelector('.expandable-content')?.clientHeight || 0;

    if (expandButton && expandableContentWrapper && !expandableContentWrapper.id) {
      expandableContentWrapper.id = `expandableContent_${id}`;
      expandButton.setAttribute('aria-controls', `expandableContent_${id}`);
    }

    const blockData: IExpandableBlock = {
      element: element,
      expandButton: expandButton,
      expandableContentWrapper: expandableContentWrapper,
      expandableContent: expandableContent,
      expandableScroll: expandableScroll,
      expandedHeight: expandedHeight,
    };

    expandableBlocks.push(blockData);

    expandButton?.addEventListener('click', (e: Event) => {
      this.toggleExpand(blockData);
    });

    window.onresize = () => {
      expandableBlocks.forEach((block: any) => {
        block.expandedHeight = block.expandableContent?.clientHeight || 0;

        if (block.element.classList.contains('expanded')) {
          gsap.to(block.expandableContentWrapper, {
            height: block.expandedHeight + 15,
            duration: 0,
          });
        }
      });
    };
  }

  toggleExpand(blockData: IExpandableBlock) {
    blockData.expandedHeight = blockData.expandableContent?.clientHeight || 0;
    const expandDuration = 0.5 - 30 / blockData.expandedHeight;

    if (blockData.element?.classList.contains('expanded')) {
      blockData.element?.classList.remove('expanded');
      gsap.to(blockData.expandableContentWrapper, {
        height: 0,
        duration: expandDuration,
      });
      blockData.expandButton?.setAttribute('aria-expanded', 'false');
      blockData.element?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    } else {
      blockData.element?.classList.add('expanded');
      gsap.to(blockData.expandableContentWrapper, {
        height: blockData.expandedHeight + 15,
        duration: expandDuration,
      });
      blockData.expandButton?.setAttribute('aria-expanded', 'true');
      blockData.expandableScroll?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }
}
